// Helper function to reload page - compatible with Flutter WebView
function reloadPage() {
    // Riesenia wrapper app — native reload through the bridge. The timeout keeps the
    // old behaviour as a safety net: without it a bridge that never reports APP_READY
    // would queue the call forever and the page would never reload.
    if (window.AppBridge && window.AppBridge.isApp) {
        window.AppBridge.callBridge("RELOAD", undefined, { timeoutMs: 5000 }).catch(() => {
            window.location.reload();
        });

        return;
    }

    if (window.FlutterApp && window.FlutterApp.postMessage) {
        window.FlutterApp.postMessage("reload");
    } else {
        window.location.reload();
    }
}

// Helper function to notify logout - for Flutter WebView
function notifyLogout() {
    if (window.FlutterApp && window.FlutterApp.postMessage) {
        window.FlutterApp.postMessage("logout");
    }
}

// Make functions available globally
window.reloadPage = reloadPage;
window.notifyLogout = notifyLogout;

export { reloadPage, notifyLogout };
